import { render } from "./CameraPhotos.vue?vue&type=template&id=e0219b02&scoped=true"
import script from "./CameraPhotos.vue?vue&type=script&lang=js"
export * from "./CameraPhotos.vue?vue&type=script&lang=js"

import "./CameraPhotos.vue?vue&type=style&index=0&id=e0219b02&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0219b02"]])

export default __exports__